import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { ResetPasswordForm } from '../components/forms/ResetPasswordForm'
import { useApp } from '../hooks/useApp'
import { callAxios } from '../hooks/useAxios'
import { ResetPasswordData } from '../types/auth'
import { PageText } from '../components/atoms/PageText'
import { TopTitle } from '../components/atoms/TopTitle'

export function ForgotPasswordPage(): React.ReactElement {

  const { t, i18n } = useTranslation()
  const app = useApp()

  const onSubmit = (data: ResetPasswordData) => {
    callAxios({
      method: 'POST',
      url: '/auth/reset-password',
    }, { ...data, language: i18n.language }).then(res => {
      if (res.success) {
        app.addInfo(t('Link sent. Please check your email.'))
      } else {
        app.addError(res)
      }
    })
  }

  return (
    <Fragment>
      <TopTitle title={t('Fixing Access Problem')}/>
      <PageText sx={{ my: 2 }}><Trans>Give the email address you used to register your account and we will send you a link to reset your password or verify your email.</Trans></PageText>
      <ResetPasswordForm onSubmit={onSubmit}/>
    </Fragment>
  )
}
